import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';
// avoid circular reference
import { Spinner } from '../components/Spinner';

interface SpinnerContextProps {
  setLoading: (loading: boolean) => void;
}

const SpinnerContext = createContext<SpinnerContextProps>({ setLoading: () => {} });

function SpinnerProvider(props: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <SpinnerContext.Provider
      value={{
        setLoading: setOpen,
      }}
    >
      {props.children}
      <Spinner open={open} />
    </SpinnerContext.Provider>
  );
}

function useSpinner() {
  return useContext(SpinnerContext);
}

export { SpinnerProvider, useSpinner };
